import React, { useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import _ from 'lodash';
import RequiresLogin from 'components/RequiresLogin';
import {
  Dropdown,
  DropdownMenu,
  DropdownItem,
  NavLink,
  Accordion,
  AccordionBody,
  AccordionItem,
  AccordionHeader,
  Nav,
} from 'reactstrap';
import Router from 'next/router';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';
import Link from 'next/link';
import OnlyOnSmallScreen from './OnlyOnSmallScreen';

const NavbarConfigNavigation = ({
  link,
  isHamburgerMenuOpen,
  toggleHamburgerMenu,
}) => {
  const [isDropDownOpen, setIsDropDownOpen] = useState(false);
  const [openAccordionId, setOpenAccordionId] = useState(null);

  const handleAccordionToggle = id => {
    if (openAccordionId === id) {
      setOpenAccordionId(null); // Close accordion if it's already open
    } else {
      setOpenAccordionId(id); // Open the clicked accordion
    }
  };

  const handleAccordionClick = href => {
    if (isHamburgerMenuOpen) {
      toggleHamburgerMenu();
    }
    Router.push(href);
  };

  return (
    <>
      <OnlyOnSmallScreen>
        <Accordion
          className="d-lg-none "
          flush
          open={openAccordionId}
          // reactstrap have forgotten to add toggle prop to Accordion types
          // @ts-ignore
          toggle={handleAccordionToggle}
        >
          <AccordionItem className="nav-accordion-item">
            <AccordionHeader
              targetId={link.id}
              className="d-flex nav-accordion-header"
            >
              <Nav
                onClick={() => handleAccordionClick(link.link)}
                className="link-text text-uppercase"
              >
                {link.label}
              </Nav>
              {link.subLinks && link.subLinks.length > 0 && (
                <FontAwesomeIcon
                  icon={
                    openAccordionId === link.id ? faChevronUp : faChevronDown
                  }
                  color="light"
                  className="float-end"
                />
              )}
            </AccordionHeader>

            {link.subLinks && link.subLinks.length > 0 && (
              <AccordionBody accordionId={link.id}>
                {link.subLinks.map(x => {
                  if (x.requireLoggedIn) {
                    return (
                      <div key={x.id}>
                        <RequiresLogin>
                          <Link
                            href={x.link}
                            onClick={
                              isHamburgerMenuOpen
                                ? toggleHamburgerMenu
                                : undefined
                            }
                          >
                            <div className="text-capitalize accoridion-sublink-text">
                              {x.label}
                            </div>
                          </Link>
                        </RequiresLogin>
                      </div>
                    );
                  }
                  return (
                    <div key={x.id}>
                      <Link
                        href={x.link}
                        onClick={
                          isHamburgerMenuOpen ? toggleHamburgerMenu : undefined
                        }
                      >
                        <div className="text-capitalize accoridion-sublink-text">
                          {x.label}
                        </div>
                      </Link>
                    </div>
                  );
                })}
              </AccordionBody>
            )}
          </AccordionItem>
        </Accordion>
      </OnlyOnSmallScreen>

      <Dropdown
        nav
        inNavbar
        key={link.id}
        isOpen={isDropDownOpen}
        onMouseLeave={() => setIsDropDownOpen(false)}
        toggle={() => {}}
        tag="div"
        className="navbar-nav-dropdown d-none d-lg-block"
      >
        <div onMouseEnter={() => setIsDropDownOpen(true)} className="px-1">
          <Link
            className="px-xl-1 navbar-nav-dropdown-link nav-link"
            onClick={isHamburgerMenuOpen ? toggleHamburgerMenu : undefined}
            href={link.link}
            target={link.openInNewTab ? '_blank' : '_self'}
          >
            <div>{link.label}</div>
          </Link>
        </div>
        {link.subLinks && !_.isEmpty(link.subLinks) && (
          <DropdownMenu className="mt-0 navbar-nav-dropdown-menu">
            {link.subLinks.map(x => {
              if (x.requireLoggedIn) {
                return (
                  <RequiresLogin key={x.id}>
                    <DropdownItem className="navbar-nav-dropdown-item">
                      <Link
                        href={x.link}
                        target={x.openInNewTab ? '_blank' : '_self'}
                      >
                        <div className="navbar-nav-dropdown-text">
                          {x.label}
                        </div>
                      </Link>
                    </DropdownItem>
                  </RequiresLogin>
                );
              }
              return (
                <DropdownItem className="navbar-nav-dropdown-item" key={x.id}>
                  <Link
                    href={x.link}
                    target={x.openInNewTab ? '_blank' : '_self'}
                  >
                    <div className="navbar-nav-dropdown-text">{x.label}</div>
                  </Link>
                </DropdownItem>
              );
            })}
          </DropdownMenu>
        )}
      </Dropdown>
    </>
  );
};

const PageNavigation = ({
  shopConfig,
  toggleHamburgerMenu,
  isHamburgerMenuOpen,
  asPath,
}) => {
  const { pages, navbarConfig } = shopConfig;
  const sortedPages = pages.sort((a, b) => a.sortOrder - b.sortOrder);
  const activePath = decodeURI(asPath);

  if (navbarConfig && !_.isEmpty(navbarConfig.links)) {
    return shopConfig.navbarConfig.links.map(link => {
      if (link.requireLoggedIn) {
        return (
          <RequiresLogin key={link.id}>
            <NavbarConfigNavigation
              link={link}
              isHamburgerMenuOpen={isHamburgerMenuOpen}
              toggleHamburgerMenu={toggleHamburgerMenu}
            />
          </RequiresLogin>
        );
      }
      return (
        <NavbarConfigNavigation
          key={link.id}
          link={link}
          isHamburgerMenuOpen={isHamburgerMenuOpen}
          toggleHamburgerMenu={toggleHamburgerMenu}
        />
      );
    });
  }

  return (
    <>
      <div className="d-lg-flex flex-wrap w-100 text-nowrap justify-content-start align-items-center page-navigation">
        {sortedPages
          .filter(page => page.type === 'infoPage')
          .map(page => (
            <NavLink
              active={_.includes(activePath, page.name)}
              className="px-lg-1 py-2 mx-2"
              key={page.name}
              onClick={isHamburgerMenuOpen ? toggleHamburgerMenu : undefined}
              href={`/${page.name}`}
            >
              {page.name}
            </NavLink>
          ))}
      </div>
    </>
  );
};
const mapStateToProps = ({ shopConfig }) => ({
  shopConfig,
});

export default connect(mapStateToProps)(PageNavigation);

PageNavigation.propTypes = {
  shopConfig: PropTypes.object.isRequired,
  sessionUser: PropTypes.object,
  authentication: PropTypes.object,
  toggleHamburgerMenu: PropTypes.func.isRequired,
  isHamburgerMenuOpen: PropTypes.bool.isRequired,
  asPath: PropTypes.string.isRequired,
};

PageNavigation.defaultProps = {
  sessionUser: null,
};
